/**
 * Verifica che il ruolo sia di amministratore
 */
export function isRoleAdministrator(roleId?: number) {
  return roleId === 1;
}
